import React, { PropsWithChildren } from 'react';
import { Spinner } from '@amzn/awsui-components-react-v3';
import { LoadingOverlayProps } from './loadingOverlay.interface';
import './loadingOverlay.scss';

export const LoadingOverlay = ({
	hideOverlay,
	children,
}: PropsWithChildren<LoadingOverlayProps>) => {
	return (
		<div hidden={hideOverlay}>
			<div className="loading-overlay" />
			{children ? (
				<div className="loading-message">{children}</div>
			) : (
				<div className="loading-spinner">
					<Spinner size="large"/>
				</div>
			)}
		</div>
	);
};
